<template>
    <div class="page-wrapper flex">
        <div class="menus flex flex-direction flex-shrink">
            <div class="text-white text-bold text-df text-center margin-tb">项目任务分解</div>
            <el-button v-if="!readonly" class="btn mid bg-orange radius self-center" type="warning" @click="addStage(false)">
                <i class="el-icon-plus margin-right-xs"></i>添加
            </el-button>
            <div v-for="(item,index) in menus" :key="index" class="flex flex-direction">
                <div :class="{ active: cur_sid  === item.id}" class="menu-item flex align-center justify-between padding-lr-sm" @click="stageChange(item.id)">
                    <div class="flex flex-direction flex-sub w-100">
                        <div :class="{ active: cur_sid  === item.id}" class="title margin-top-sm">{{ item.name }}</div>
                        <div class="flex align-center justify-between margin-top-xs">
                            <i :class="[{active: cur_sid === item.id}]" class="el-icon-user-solid flex-sub ovHide">{{ item.member_name
                                }}</i>
                            <i v-if="show_score" :class="[{active: cur_sid === item.id}]" class="el-icon-star-on flex-sub">{{ item.score || 0
                                }}</i>
                        </div>
                    </div>
                    <i v-if="!readonly" :class="[{active: cur_sid === item.id}]" class="max el-icon-more" @click="addStage(item)"></i>
                </div>
            </div>
        </div>
        <div v-if="cur_sid" class="bg-white radius-lg padding margin-left-sm flex-sub">
            <div class="search-container flex align-center justify-between">
                <div class="flex align-center">
                    <el-button v-if="!readonly" class="btn max bg-orange radius margin-right-sm" type="warning" @click="addTask(false,cur_sid)">
                        <i class="el-icon-plus margin-right-xs"></i>添加目标
                    </el-button>
                    <router-link :to="`/web/staff/task/assignment/${pid}/${pname}`">
                        <el-button class="btn max radius" type="primary">{{ state === 0 ? '设置权重赋分' : '修改权重赋分' }}
                        </el-button>
                    </router-link>
                </div>
                <div class="search-container min flex align-center">
                    <el-date-picker
                        v-model="export_date"
                        end-placeholder="结束日期"
                        range-separator="至"
                        start-placeholder="开始日期"
                        type="daterange">
                    </el-date-picker>
                    <el-button class="search-submit" type="primary" @click="exportPro">导出任务清单</el-button>
                </div>
            </div>
            <div class="page-list flex flex-direction margin-top-sm">
                <el-table
                    v-loading="loading"
                    :data="lists"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    border
                    default-expand-all
                    header-row-class-name="table-header"
                    row-key="id"
                    style="width: 100%">
                    <el-table-column label="任务名称" prop="name">
                        <template slot-scope="scope">
                            <i :class="scope.row.dj === 2 ? 'text-black text-bold' : ''" class="cursor" @click="addTask(scope.row,-1)">{{ scope.row.name
                                }}</i>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="!readonly" label="操作" prop="client" width="170">
                        <template slot-scope="scope">
                            <div v-if="scope.row.dj !== 4" class="table-item">
                                <el-button class="radius" type="primary" @click="addTask(false,scope.row.id)">
                                    添加子任务
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="show_score" label="进度" prop="level" width="170">
                        <template slot-scope="scope">
                            <div class="flex align-center justify-center">
                                <div :class="scope.row.state | state_color" class="task-tag radius">
                                    {{ scope.row.state | state(scope.row.is_change)
                                    }}
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="优先级" prop="level" width="170">
                        <template slot-scope="scope">
                            <div class="table-item">
                                <el-tag :type="scope.row.level | level_color" class=" radius">{{ scope.row.level | level
                                    }}
                                </el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="show_score" label="分值" prop="p_mid" width="100">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.score || '0' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="负责人" prop="p_mid" width="170">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.member_name || '--' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="完成时间" prop="end_time" width="170">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.end_time }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div v-else class="bg-white radius-lg padding margin-left-sm flex-sub flex align-center justify-center">
            <empty></empty>
        </div>

        <task-add-stage-dialog :dialog-visible="addStageDialog" :info="cur_stage" :pid="pid" @watchState="watchState"></task-add-stage-dialog>
        <task-add-task-dialog :dialog-visible="addTaskDialog" :pid="pid" :pname="pname" :sid="cur_task_sid" :tid="cur_task_id" @watchState="watchState"></task-add-task-dialog>
        <task-detail-task-dialog :dialog-visible="addTaskDetailDialog" :readonly="false" :tid="cur_task_id" @watchDetailState="watchDetailState"></task-detail-task-dialog>
    </div>
</template>

<script>

import {exportProDetail, getProjectStatus, getTaskList, getTopTaskList, isExProjectDetail} from "@/api";
import TaskAddStageDialog from "@/views/web/staff/components/TaskAddStageDialog";
import TaskAddTaskDialog from "@/views/web/staff/components/TaskAddTaskDialog";
import {level_color, levels, task_color, task_state} from "@/utils/const";
import TaskDetailTaskDialog from "@/views/web/staff/components/TaskDetailTaskDialog";
import {confirm, downloadFile} from "@/utils/utils";

export default {
    name: "task-list",
    components: {TaskDetailTaskDialog, TaskAddTaskDialog, TaskAddStageDialog},
    data() {
        return {
            pid: 0,
            pname: '',
            export_date: [],
            menus: [],
            cur_sid: 0,
            lists: [],
            loading: false,
            cur_stage: '',
            addStageDialog: false,
            cur_task_id: 0,
            cur_task_sid: 0,
            addTaskDialog: false,
            addTaskDetailDialog: false,
            show_score: false,//是否显示分值
            readonly: true,//是否显示分值
            state: 0
        }
    },
    created() {
        this.pid = Number(this.$route.params.id || 0)
        this.pname = this.$route.params.title
        this.$emit('setIndex', [1,5], `${this.pname}`, true)
        this.notice()
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async notice() {
            let _data = await isExProjectDetail(this.pid)
            if (_data.data) {
                confirm(`提醒`,`项目信息尚未完善，你确定要进行任务分解吗？`,()=>{
                },'确认',false)
            }
        },
        async init() {
            let _data = await getProjectStatus(this.pid)
            this.show_score = _data.data.status === 1 || _data.data.status === 2 || _data.data.status === 3
            this.readonly = _data.data.is_operation === 0 || _data.data.status === 1
            this.state = _data.data.status

            _data = await getTopTaskList(this.pid)
            this.menus = _data.data
            if (_data.data.length > 0) {
                this.cur_sid = _data.data[0].id
                this.getTaskList()
            }
        },
        async getTaskList() {
            this.loading = true
            let _data = await getTaskList(this.cur_sid)
            this.lists = _data.data
            this.loading = false

        },
        async exportPro() {
            let _data = await exportProDetail(this.pid, this.cur_sid, this.export_date[0], this.export_date[1])
            downloadFile(_data.data, '任务清单.xlsx')
        },
        stageChange(id) {
            this.cur_sid = id
            this.getTaskList()
        },
        addStage(data) {
            if (data) this.cur_stage = data
            this.addStageDialog = true
        },
        addTask(data, sid) {
            this.cur_task_sid = sid
            if (data) {
                this.cur_task_id = data.id
            } else {
                this.cur_task_id = 0
            }
            if (data.state) {
                this.addTaskDetailDialog = true
            } else {
                this.addTaskDialog = true
            }
        },
        watchState(data) {
            if (data) {
                switch (data.type) {
                    case 'stage' :
                        this.init()
                        break
                    case 'task' :
                        this.getTaskList()
                        break
                }
            }
            this.cur_stage = ''
            this.cur_task_id = 0
            this.addStageDialog = false
            this.addTaskDialog = false
        },
        watchDetailState(data){
            if (data) {
                this.getTaskList()
            } else {
                this.cur_task_id = 0
                this.addTaskDetailDialog = false;
            }
        },
    },
    filters: {
        //1赋分审核中 2赋分审核通过（进行中） 3赋分驳回 4修改任务审核中 5修改任务驳回 6任务评审审核中 7任务完成 8逾期 9任务评审驳回
        state(val, is_change) { //任务状态
           return task_state(val,is_change)
        },
        state_color(val) {//任务状态颜色
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
           return task_color(val)
        },
        level(val) {
            return levels.find(f => Number(f.value) === val).label
        },
        level_color(val) {
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            return level_color(val)
        }
    },

}
</script>

<style lang="scss" scoped>
.page-wrapper {
    .menus {
        width: 210px;
        border-radius: 0 20px 20px 0;
        background: #0a2240;

        .menu-item {
            width: 100%;
            height: 85px;
            background: none;
            position: relative;

            &.active, &:hover {
                background-color: #011733;
                border-radius: 4px;
                cursor: pointer;
            }

            &.active {
                &:before {
                    position: absolute;
                    right: -8px;
                    border-top: 8px solid transparent;
                    border-left: 8px solid #233953;
                    border-bottom: 8px solid transparent;
                    top: 50%;
                    transform: translateY(-50%);
                    content: '';
                }
            }

            .title {
                font-size: 16px;
                color: var(--white);

                &.active {
                    color: var(--orange);

                }
            }

            i {
                font-size: 12px;
                color: var(--white);

                &.max {
                    font-size: 16px;
                    transform: rotate(90deg);
                    cursor: pointer;
                }

                &.active {
                    color: var(--orange);
                }
            }
        }
    }
}
</style>
